import axios from "axios";
const API_ENDPOINT =
  process.env.REACT_APP_BASE_URL || "https://Api2.mr-rent.net";

const token =localStorage.getItem('authToken')
const headersApplicationJson = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
};

// Global 401 handler
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      try {
        localStorage.removeItem('authToken');
      } catch {}
      // Hard redirect to login
      if (typeof window !== 'undefined') {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export const getCustomerList = (params) => {
  const search = params?.search ? `&search=${params?.search}` : "";
  const url = `${API_ENDPOINT}/api/customer-list?start_date=${params.start_date}&end_date=${params?.end_date}${search}&page=${params?.page}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

export const getBookingList = (params) => {
  const search = params?.search ? `&search=${params?.search}` : "";
  const startDate = params?.start_date
    ? `&start_date=${params?.start_date}`
    : "";
  const endDate = params?.end_date ? `&end_date=${params?.end_date}` : "";
  const page = params?.page ? `&page=${params?.page}` : "";

  const url = `${API_ENDPOINT}/booking/list/?type=${
    params?.type || "all"
  }${startDate}${endDate}${search}${page}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

export const getMonthlySummary = (month, year) => {
  const url = `${API_ENDPOINT}/booking/monthly-booking-summary/?month=${month}&year=${year}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};
export const getMonthlyType = (month, year) => {
  const url = `${API_ENDPOINT}/booking/top-booking-car/?month=${month}&year=${year}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};
export const getMonthlyRental = (month, year) => {
  const url = `${API_ENDPOINT}/booking/location-booking-report/?month=${month}&year=${year}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};
export const getLicenseList = (params) => {
  const search = params?.search ? `&search=${params?.search}` : "";
  const startDate = params?.start_date
    ? `&start_date=${params?.start_date}`
    : "";
  const endDate = params?.end_date ? `&end_date=${params?.end_date}` : "";
  const page = params?.page ? `&page=${params?.page}` : "";

  const url = `${API_ENDPOINT}/api/licenses?type=${
    params?.type || "all"
  }${startDate}${endDate}${search}${page}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

export const updateLicenseStatus = (data,id) => {
  const url = `${API_ENDPOINT}/api/update-licence-status/${id}/`;
  return axios.patch(url,data, {
    headers: headersApplicationJson,
  });
};

export const getAdminList = (search) => {
  const url = `${API_ENDPOINT}/api/admins/?search=${search}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

export const updateAdminDetails = (data) => {
  const url = `${API_ENDPOINT}/api/admins/`;
  return axios.patch(url, data, {
    headers: headersApplicationJson,
  });
};

export const updateAdminStatus = (data) => {
  const url = `${API_ENDPOINT}/api/admins/`;
  return axios.patch(url, data, {
    headers: headersApplicationJson,
  });
};

export const deleteAdmin = (data) => {
  let config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `${API_ENDPOINT}/api/admins/`,
    headers:headersApplicationJson,
    data: data,
  };

  return axios(config);
};
export const createAdmin = (data) => {
  const url = `${API_ENDPOINT}/api/admins/`;
  return axios.post(url, data, {
    headers: headersApplicationJson,
  });
};
export const loginUser =(data)=>{
 
  const url = `${API_ENDPOINT}/api/login/`;
  return axios.post(url, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export const getCarList = (params) => {
  const search = params?.search ? `&search=${params?.search}` : "";
  const startDate = params?.start_date
    ? `&start_date=${params?.start_date}`
    : "";
  const endDate = params?.end_date ? `&end_date=${params?.end_date}` : "";
  const page = params?.page ? `&page=${params?.page}` : "";
  const pageSize = params?.page_size ? `&page_size=${params?.page_size}` : "";

  const url = `${API_ENDPOINT}/car/car_list/?${startDate}${endDate}${search}${page}${pageSize}`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

export const getCarDetail = (id) => {
  const url = `${API_ENDPOINT}/car/car_detail/${id}/`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

export const deleteCar = (id) => {
  const url = `${API_ENDPOINT}/car/car_detail/${id}/`;
  return axios.delete(url, {
    headers: headersApplicationJson,
  });
};

// Fuel Types (for filter dropdowns)
export const getFuelTypesForFilter = () => {
  const url = `${API_ENDPOINT}/car/fuel_type/?used_for=filter`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

// Car Types (for filter dropdowns)
export const getCarTypesForFilter = () => {
  const url = `${API_ENDPOINT}/car/car_type/?used_for=filter`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

// Transmissions (for filter dropdowns)
export const getTransmissionsForFilter = () => {
  const url = `${API_ENDPOINT}/car/transmissions/`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

// Body Types (for filter dropdowns)
export const getBodyTypesForFilter = () => {
  const url = `${API_ENDPOINT}/car/body_type/`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

// Create car
export const createCar = (data) => {
  const url = `${API_ENDPOINT}/car/add-car/`;
  return axios.post(url, data, {
    headers: headersApplicationJson,
  });
};

// Update car (PUT)
export const updateCar = (id, data) => {
  const url = `${API_ENDPOINT}/car/car_detail/${id}/`;
  return axios.put(url, data, {
    headers: headersApplicationJson,
  });
};

// Operating Locations (for dropdown)
export const getOperatingLocations = () => {
  const url = `${API_ENDPOINT}/master/operating_locations/`;
  return axios.get(url, {
    headers: headersApplicationJson,
  });
};

// Reset Password
export const resetPassword = (data) => {
  const data_={
    from:'D',
    ...data
  }
  const url = `${API_ENDPOINT}/api/reset-password/`;
  return axios.post(url, data_, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Upload image (common function for both cover and thumbnail)
export const uploadImage = (imageFile, uploadType = null, carId = null) => {
  const formData = new FormData();
  formData.append('image', imageFile);
  
  // Add upload_type and car_id for thumbnail uploads
  if (uploadType) {
    formData.append('upload_type', uploadType);
  }
  if (carId) {
    formData.append('car_id', carId);
  }
  
  const url = `${API_ENDPOINT}/api/upload-image/`;
  return axios.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

// Upload cover image (returns image URL)
export const uploadCoverImage = (imageFile, carId) => {
  return uploadImage(imageFile, 'car_thumbnail', carId);
};

// Upload secondary images (after car creation)
export const uploadSecondaryImage = (imageFile, carId) => {
  return uploadImage(imageFile, 'car_other', carId);
};

export const deleteImage = (value) => {
  const url = `${API_ENDPOINT}/api/delete-media/`;
  return axios.delete(url, {
    headers: headersApplicationJson,
    data: {
      file_url: value
    }
  });
}

// Download invoice for booking
export const downloadBookingInvoice = (bookingId) => {
  const url = `${API_ENDPOINT}/booking/invoice/${bookingId}/download/`;
  return axios.get(url, {
    headers: headersApplicationJson,
    responseType: 'blob', // Set to blob to handle binary file data from force download
  });
}
